import React from 'react';
import { Mail, Globe, Phone, ArrowRight, CheckCircle2 } from 'lucide-react';
import { SlideLayout } from '../SlideLayout';
interface SlideProps {
  isActive: boolean;
  currentSlide: number;
  totalSlides: number;
  onNext: () => void;
  onPrev: () => void;
}
export function ProspectNextStepsSlide(props: SlideProps) {
  return <SlideLayout {...props} theme="brand" data-id="element-209">
      <div className="flex flex-col items-center text-center max-w-4xl mx-auto" data-id="element-210">
        <h2 className="text-5xl md:text-6xl font-bold text-white mb-6" data-id="element-211">
          Ready to Save Time?
        </h2>

        <p className="text-xl text-indigo-100 mb-10 max-w-2xl" data-id="element-212">
          Start generating professional assessments in seconds. No credit card
          required for the free trial.
        </p>

        <div className="flex flex-col md:flex-row gap-4 mb-12 w-full justify-center" data-id="element-213">
          <button className="bg-white text-indigo-600 px-8 py-4 rounded-full font-bold text-lg hover:bg-indigo-50 transition-all shadow-lg hover:shadow-xl hover:scale-105 flex items-center justify-center gap-2 min-w-[200px]" data-id="element-214">
            Start Free Trial
            <ArrowRight className="w-5 h-5" data-id="element-215" />
          </button>
          <button className="bg-indigo-700 text-white border border-indigo-500 px-8 py-4 rounded-full font-bold text-lg hover:bg-indigo-600 transition-all shadow-lg min-w-[200px]" data-id="element-216">
            Book a Demo
          </button>
        </div>

        <div className="flex gap-6 text-indigo-200 text-sm mb-12" data-id="element-217">
          <div className="flex items-center gap-2" data-id="element-218">
            <CheckCircle2 className="w-4 h-4 text-emerald-400" data-id="element-219" /> 14-day free
            trial
          </div>
          <div className="flex items-center gap-2" data-id="element-220">
            <CheckCircle2 className="w-4 h-4 text-emerald-400" data-id="element-221" /> Cancel anytime
          </div>
          <div className="flex items-center gap-2" data-id="element-222">
            <CheckCircle2 className="w-4 h-4 text-emerald-400" data-id="element-223" /> 24/7 Support
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 w-full border-t border-white/10 pt-10" data-id="element-224">
          <a href="mailto:support@eduassess.pehlai.com" className="flex flex-col items-center p-4 hover:bg-white/5 rounded-xl transition-colors" data-id="element-225">
            <Mail className="w-6 h-6 text-amber-400 mb-3" data-id="element-226" />
            <span className="text-white font-medium text-sm" data-id="element-227">
              support@eduassess.pehlai.com
            </span>
          </a>
          <a href="https://www.eduassess.pehlai.com" className="flex flex-col items-center p-4 hover:bg-white/5 rounded-xl transition-colors" data-id="element-228">
            <Globe className="w-6 h-6 text-emerald-400 mb-3" data-id="element-229" />
            <span className="text-white font-medium text-sm" data-id="element-230">
              www.eduassess.pehlai.com
            </span>
          </a>
          <a href="tel:+923205011329" className="flex flex-col items-center p-4 hover:bg-white/5 rounded-xl transition-colors" data-id="element-231">
            <Phone className="w-6 h-6 text-indigo-300 mb-3" data-id="element-232" />
            <span className="text-white font-medium text-sm" data-id="element-233">
              +92 320 5011 329
            </span>
          </a>
        </div>
      </div>
    </SlideLayout>;
}